import React, { Component, ReactElement } from 'react'
import { BaseContexts } from '../../React/Common/BaseContexts'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { QueueManagement as QueueManagementPageContent } from '../Components/Organisms/QueueManagementPage/QueueManagementPage'

/**
 * <p>Routed page wrapper for the Fast Provisioning queue management page.
 *
 * Renders the same ManageQueues content the legacy modal shows, minus the modal chrome, so the
 * new UI can open it as a v2 portal page at /CCS/App/v2/queueManagement. Access is gated by
 * RouteGuard (the backend route-availability check for RouteID.QUEUE_MANAGEMENT).
 */
@Route(RouteID.QUEUE_MANAGEMENT)
export class QueueManagementPage extends Component {
    /**
     * <p>Renders the guarded routed page.
     *
     * @returns Queue management page component tree.
     */
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.QUEUE_MANAGEMENT}>
                <BaseContexts>
                    <QueueManagementPageContent />
                </BaseContexts>
            </RouteGuard>
        )
    }
}
